import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CreditCard, Loader2, MapPin } from "lucide-react";

const Lead = ({ x }) => {
  const [busy, setBusy] = useState(false);
  const buy = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/pm/market/${x.id}/checkout`, { origin_url: window.location.origin }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(apiError(e)); setBusy(false); }
  };
  return (
    <Card className="flex flex-col justify-between p-5" data-testid={`pm-market-lead-${x.id}`}>
      <div>
        <div className="flex items-center gap-1 font-display text-lg font-bold text-slate-900"><MapPin className="h-4 w-4" />{[x.city, x.state].filter(Boolean).join(", ") || "Florida"} {x.zip}</div>
        <div className="mt-1 text-sm text-slate-600">{[x.property_type, x.units && `${x.units} unit(s)`].filter(Boolean).join(" · ")}</div>
        {x.details && <p className="mt-2 text-xs text-slate-500">{x.details}</p>}
        <div className="mt-2 text-xs text-slate-400">Received {x.received_date}</div>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <span className="font-display text-2xl font-extrabold text-slate-900" data-testid={`pm-market-price-${x.id}`}>${x.price.toFixed(2)}</span>
        <Button className="gold-cta border-0 font-bold" onClick={buy} disabled={busy} data-testid={`pm-market-buy-${x.id}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><CreditCard className="mr-2 h-4 w-4" />Buy lead</>}</Button>
      </div>
    </Card>
  );
};

export default function PmMarket() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/pm/market").then((r) => setD(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!d) return null;
  return (
    <div className="mx-auto max-w-6xl" data-testid="pm-market-page">
      <h1 className="font-display text-3xl font-extrabold text-slate-900">Lead Marketplace</h1>
      <p className="mb-5 text-sm text-slate-600">New property owners looking for a property manager. Buy a lead and it's yours alone: Ava calls you, then emails, mails, texts and calls the owner, tries to connect them with you or book an appointment, and calls you back with the result.</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{d.leads.map((x) => <Lead key={x.id} x={x} />)}</div>
      {!d.leads.length && <Card className="p-8 text-center text-sm text-slate-500" data-testid="pm-market-empty">No leads available right now. New leads arrive every morning.</Card>}
      <h2 className="mb-3 mt-8 text-base font-bold text-slate-900 md:text-lg">Your purchased leads ({d.purchased.length})</h2>
      {d.purchased.map((x) => (
        <Card key={x.id} className="mb-2 p-4 text-sm" data-testid={`pm-market-bought-${x.id}`}>
          <b>{x.name}</b> · {x.phone} · {x.email}<div className="text-xs text-slate-500">{x.property_address || [x.city, x.state, x.zip].join(" ")} · bought {new Date(x.sold_at).toLocaleDateString()} · now in your Owner Leads</div>
        </Card>))}
    </div>
  );
}
